<template lang="pug">
.date-picker
	input.form-control(
		type="date",
		:value="inputValue",
		@input="onInput"
	)
	i.la.la-times.date-picker-clear(
		v-if="showClear && hasValue",
		title="Clear",
		@click.stop="clear"
	)
</template>

<script>
import moment from 'moment';

export default {
	name: 'DatePicker',
	props: {
		value: {
			default: null,
		},
		config: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		format() {
			return this.config.format || 'DD/MM/YYYY';
		},
		showClear() {
			return this.config.showClear !== false;
		},
		hasValue() {
			return this.value != null && this.value !== '';
		},
		inputValue() {
			if (!this.hasValue) return '';
			const m = this.parseValue(this.value);
			return m && m.isValid() ? m.format('YYYY-MM-DD') : '';
		},
	},
	methods: {
		parseValue(v) {
			if (v instanceof Date) {
				const m = moment(v);
				return m.isValid() ? m : null;
			}
			if (typeof v === 'string') {
				const strict = moment(v, [this.format, 'YYYY-MM-DD', moment.ISO_8601], true);
				if (strict.isValid()) return strict;
				const loose = moment(v);
				return loose.isValid() ? loose : null;
			}
			const m = moment(v);
			return m.isValid() ? m : null;
		},
		emitValue(next) {
			this.$emit('input', next);
			this.$emit('dp-change', next);
		},
		onInput(e) {
			const raw = e.target.value;
			if (!raw) {
				this.emitValue(null);
				return;
			}
			this.emitValue(moment(raw, 'YYYY-MM-DD').format(this.format));
		},
		clear() {
			this.emitValue(null);
		},
	},
};
</script>

<style lang="scss" scoped>
.date-picker {
	position: relative;

	.form-control {
		padding-right: 2rem;
	}
}
.date-picker-clear {
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%);
	cursor: pointer;
	opacity: 0.55;
	font-size: 1rem;
	z-index: 2;
	&:hover {
		opacity: 1;
		color: #dc3545;
	}
}
</style>
